<div class="st-form">
  <app-st-impersonation-floating-banner [impersonatedEmail]="this.impersonatedEmail"
                                        [username]="this.username"
                                        [roleName]="this.consultantRoleName"
                                        (exitViewAs)="this.onExitViewAs($event)"
  >

  </app-st-impersonation-floating-banner>
</div>
<app-st-banner [idVal]="'banner-id'" [breadCrumbs]="this.breadCrumbs"
               [hasElementTags]="false" [elementTags]="[]" [requiresSignOutButton]="true"
></app-st-banner>
<br><br><br><br><br><br>
<div class="container-xxl">
  <div class="row pt-4 pb5">
    <div class="col-2 d-flex justify-content-center neg-margin">
      <!--<app-st-profile-picture></app-st-profile-picture>-->
    </div>
    <div class="col-8">
      <app-st-header-title [inputVal]="'Your Saved Searches'"></app-st-header-title>
    </div>
  </div>
  <br>
  <div *ngIf="showPageErrorMessages" class="container st-form text-danger" #goUp>
    <app-st-span [inputVal]="'An error has occurred: '"></app-st-span>
    <div *ngFor="let errorMsg of pageErrorMessages" class="alert alert-danger" role="alert">
      <b>{{errorMsg.field}}:</b> {{errorMsg.detail}}
    </div>
    <br>
  </div>
  <div *ngIf="this.showPageSuccessMessages" class="container st-form text-success" #goUp>
    <div *ngFor="let successMsg of pageSuccessMessages" class="alert alert-success" role="alert">
      <b>{{successMsg.field}}:</b> {{successMsg.detail}}
    </div>
    <br>
  </div>
  <br>

  <div class="container st-form">
    <div class="col2 d-grid gap-2 d-md-flex justify-content-md-end align-items-end">
      <app-st-button-cancel [idVal]="'top-cancel-button-id'" [label]="'Cancel'" [primary]="false"
                            (click)="this.onCancel()"></app-st-button-cancel>
      <app-st-button-delete-all *ngIf="!this.readOnly" [idVal]="'top-reset-filter-button1-id'" [label]="'Reset Filter'"
                            (click)="this.resetFilters()"></app-st-button-delete-all>
      <app-st-button *ngIf="(this.username && this.impersonatedEmail == null) ||
                        (this.impersonatedEmail != null && this.consultantRoleName == 'COLLABORATIVE_ACCESS')"
                     [idVal]="'top-save-button-id'" [label]="'Submit'" [primary]="true"
                     (click)="this.onSubmit(false)"></app-st-button>
      <app-st-button *ngIf="(this.username && this.impersonatedEmail == null) ||
                        (this.impersonatedEmail != null && this.consultantRoleName == 'COLLABORATIVE_ACCESS')"
                     [idVal]="'top-save-and-button1-id'" [label]="'Submit and Apply'" [primary]="true"
                     (click)="this.onSubmit(true)"></app-st-button>
    </div>
    <br>

    <div id="NONPROFIT_SEARCH">
      <app-st-header-title [inputVal]="'Search Nonprofits Filters Template'"></app-st-header-title>
      <div>
        <app-st-input-text [idVal]="'nonprofit-search-filter-name-text-id'" [label]="''" [placeHolderVal]="'Nonprofit Search Filter Name'" [inputVal]="savedNonprofitSearchName" [width]="'90%'"
                           [disabled]="this.readOnly"
        ></app-st-input-text>
        <br>
        <app-st-span [inputVal]="'Include Nonprofit Names: '"></app-st-span><br><app-st-span [inputVal]="'Separate multiple nonprofit names by commas.'"></app-st-span>
        <!--<app-st-input-text [idVal]="'nonprofit-name-with-text-id'" [label]="''" [placeHolderVal]="'Nonprofit Name (With Words)'" [inputVal]="nonprofit_nameInput" [width]="'95%'"></app-st-input-text>-->
        <app-st-autocomplete [idVal]="'nonprofit-name-with-text-id'" [label]="''" [placeHolderVal]="'Nonprofit Name (With Words)'" [inputVal]="nonprofit_nameInput" [maxLength]="200" [width]="'95%'"
                             [items]="this.companyNamesAutocomplete" [disabled]="this.readOnly"
        ></app-st-autocomplete>
        <!--
        <app-st-input-text [idVal]="'nonprofit-name-without-text-id'" [label]="''" [placeHolderVal]="'Nonprofit Name (Without Words)'" [inputVal]="nonprofit_nameWithoutInput" [width]="'95%'"></app-st-input-text>
        -->
        <br>
        <app-st-span [inputVal]="'Include EINs: '"></app-st-span><app-st-span [inputVal]="'Separate multiple eins by commas.'"></app-st-span>
        <app-st-input-text [idVal]="'nonprofit-ein-text-id'" [label]="''" [placeHolderVal]="'Include EINs'" [width]="'95%'"
                           [disabled]="this.readOnly"
        ></app-st-input-text>
        <!--<app-st-input-text [idVal]="'nonprofit-state-text-id'" [label]="''" [placeHolderVal]="'State'" [inputVal]="nonprofit_stateInput" [width]="'95%'"></app-st-input-text>-->
        <br>
        <div>
          <input class="form-check-input radio-button-properties" type="radio" value="'AND'" id="flexRadioIncludeRevocationList"
                 (click)="toggleRevokeLogicalExpression()" [checked]="includeTaxExemptRevoked" [disabled]="this.readOnly">
          <label class="form-check-label checkbox-text webtext-black" for="flexRadioIncludeRevocationList">
            &nbsp;Include Orgs In Tax Exempt Revocation List
          </label>
        </div>
        <br>
        <app-st-span [inputVal]="'Include Cities: '"></app-st-span><app-st-span [inputVal]="'Separate multiple cities by commas.'"></app-st-span>
        <!--<app-st-input-text [idVal]="'nonprofit-cities-text-id'" [label]="''" [placeHolderVal]="'Cities'" [inputVal]="nonprofit_citiesInput" [width]="'95%'"></app-st-input-text>-->
        <app-st-autocomplete-key-lookup [idVal]="'nonprofit-cities-text-id'" [label]="''" [placeHolderVal]="'Include Cities'" [inputVal]="nonprofit_citiesInput" [maxLength]="200" [width]="'95%'" [keyLookup]="'city'"
                                        [items]="this.citiesAutocomplete" [disabled]="this.readOnly"
        ></app-st-autocomplete-key-lookup>
        <br>
        <!--
        <app-st-span [inputVal]="'Exclude Cities: '"></app-st-span><app-st-span [inputVal]="'Separate multiple cities by commas.'"></app-st-span>
        <app-st-input-text [idVal]="'nonprofit-cities-without-text-id'" [label]="''" [placeHolderVal]="'Excluded Cities'" [inputVal]="nonprofit_citiesWithoutInput"
                           [width]="'95%'" [disabled]="this.readOnly"></app-st-input-text>
        <br>-->
        <app-st-span [inputVal]="'State: '"></app-st-span><br>
        <app-st-select *ngIf="!this.readOnly" [idVal]="'usa-dropdown-list-id'" [defaultOption]="'Select State'" [label]="''" [idKey]="'usaStateId'" [displayKey]="'usaState'" [valueKey]="'usaState'" [inputArray]="this.nonprofit_statesList"></app-st-select>
        <app-st-input-text  *ngIf="this.readOnly" [idVal]="'usa-state-text-id'" [label]="''" [placeHolderVal]="'State'"
                           [width]="'95%'" [disabled]="this.readOnly"></app-st-input-text>
        <br>
        <app-st-span [inputVal]="'Zip Code: '"></app-st-span>
        <app-st-input-text [idVal]="'nonprofit-zip-code-text-id'" [label]="''" [placeHolderVal]="'Zip Code'" [inputVal]="nonprofit_zipCodeInput" [width]="'95%'"
                           [disabled]="this.readOnly"
        ></app-st-input-text>
        <br>
        <!--
        <app-st-span [inputVal]="'Minimum Number of Years In Business: '" class="webtext-black-bold"></app-st-span>
        <app-st-input-text [idVal]="'min-years-in-business-text-id'" [label]="''" [placeHolderVal]="'Minimum Number of Years In Business'" [maxLength]="6" [width]="'95%'"></app-st-input-text>
        <br>-->
        <!--
        <app-st-input-text [idVal]="'nonprofit-counties-text-id'" [label]="''" [placeHolderVal]="'Counties'" [inputVal]="nonprofit_countiesInput" [width]="'90%'"></app-st-input-text>
        <app-st-input-text [idVal]="'nonprofit-counties-without-text-id'" [label]="''" [placeHolderVal]="'Without Counties'" [inputVal]="nonprofit_countiesWithoutInput" [width]="'90%'"></app-st-input-text>
        -->
        <!--
        <app-st-input-text [idVal]="'nonprofit-key-staff-text-id'" [label]="''" [placeHolderVal]="'Key Staff'" [inputVal]="nonprofit_keyStaffInput" [width]="'95%'"></app-st-input-text>
        -->
        <!--
        <br>
        <div>
          <button id="'nonprofit-filing-req-codes-button-id'" class="accordion webtext-black" (click)="this.toggleNonprofitFilingReqCodesFilter()">Filing Req Codes <b *ngIf="!this.nonprofit_filingReqCodeButton"> + </b><b *ngIf="this.nonprofit_filingReqCodeButton"> - </b></button>
        </div>
        <div *ngIf="this.nonprofit_filingReqCodeButton" class="panel">
          <div class="accordion-body" *ngFor="let filingReqCodeCheckbox of nonprofit_filingReqCodeCheckboxes; let i5 = index">
            <div class="form-check">
              <input class="form-check-input" type="checkbox" value="{{filingReqCodeCheckbox['filingReqCodeId']}}" id="flexCheckCheckedNonprofitFilingReqCode-{{i5}}"
                     (click)="addValToNonprofitFilingReqCodes(i5)" [checked]="filingReqCodeCheckbox['checked']">
              <label class="form-check-label checkbox-text webtext-black" for="flexCheckCheckedNonprofitFilingReqCode-{{i5}}">
                {{filingReqCodeCheckbox['description']}}
              </label>
            </div>
          </div>
        </div>-->
        <!--
        <br>
        <div>
          <button id="'nonprofit-foundation-codes-button-id'" class="accordion webtext-black" (click)="this.toggleNonprofitFoundationCodesFilter()">Foundation Codes <b *ngIf="!this.nonprofit_foundationCodeButton"> + </b><b *ngIf="this.nonprofit_foundationCodeButton"> - </b></button>
        </div>
        <div *ngIf="this.nonprofit_foundationCodeButton" class="panel">
          <div class="accordion-body" *ngFor="let foundationCodeCheckbox of nonprofit_foundationCodeCheckboxes; let i5 = index">
            <div class="form-check">
              <input class="form-check-input" type="checkbox" value="{{foundationCodeCheckbox['foundationCodeId']}}" id="flexCheckCheckedNonprofitFoundationCode-{{i5}}"
                     (click)="addValToNonprofitFoundationCodes(i5)" [checked]="foundationCodeCheckbox['checked']">
              <label class="form-check-label checkbox-text webtext-black" for="flexCheckCheckedNonprofitFoundationCode-{{i5}}">
                {{foundationCodeCheckbox['description']}}
              </label>
            </div>
          </div>
        </div>-->
        <br>
        <!--Cause Dropdown triggers the Giving Interest Dropdown-->
        <div *ngIf="!this.readOnly">
          <app-st-span [inputVal]="'Cause Category: '" class="webtext-black-bold"></app-st-span>
          <app-st-select [idVal]="'cause-category-dropdown-list-id'" [defaultOption]="'Cause Category'" [label]="''" [idKey]="'causeId'" [displayKey]="'causeDisplayName'" [valueKey]="'causeName'" [inputArray]="this.causeDropdownList" (change)="updateCauseGivingInterestsDropdown()"></app-st-select>
          <br>
          <app-st-span [inputVal]="'Select the option of your search for the selected Cause Category Giving Interest: '" class="webtext-black-bold"></app-st-span>
          <div>
            <input class="form-check-input radio-button-properties" type="radio" value="'AND'" id="flexRadioAND3"
                   (click)="trackLogicalExpression('AND')" [checked]="logicalOperatorAnd">
            <label class="form-check-label checkbox-text webtext-black" for="flexRadioAND3">
              &nbsp;AND
            </label>
            &nbsp;&nbsp;
            <input class="form-check-input radio-button-properties" type="radio" value="'OR'" id="flexRadioOR3"
                   (click)="trackLogicalExpression('OR')" [checked]="logicalOperatorOr">
            <label class="form-check-label checkbox-text webtext-black" for="flexRadioOR3">
              &nbsp;OR
            </label>
          </div>
          <br>
          <!--Giving Interest Dropdown-->

          <app-st-span [inputVal]="'Cause Category Giving Interests: '" class="webtext-black-bold"></app-st-span><br>
          <app-st-select [idVal]="'cause-giving-interests-dropdown-list-id'" [defaultOption]="'Select your Cause Category Giving Interest'" [label]="''" [idKey]="'causeGivingInterestId'" [displayKey]="'givingInterestDisplayName'" [valueKey]="'givingInterestName'" [inputArray]="this.causeGivingInterestsDropdownList"></app-st-select>
          <br>
          <div class="col2 d-grid gap-2 d-md-flex">
            <app-st-button [idVal]="'cause-giving-interests-include-button-id'" [label]="'Add (+)'" [primary]="true"
                           (click)="this.addCauseGivingInterestFilter2(true)"></app-st-button>
          </div>
        </div>
        <br>
        <i class="webtext-black" style="font-size: 12px;">As you add your Cause Category Giving Interests, the list below will populate.</i>
        <div>
          <table class="table table-striped webtext-black" style="width:95%; border-radius: 10px">
            <thead>
            <tr>
              <th style="width:85%">Cause Category Giving Interest Query</th>
              <th style="width:15%">Action</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let row of this.nonprofit_causeGivingInterestsList">
              <td>{{row}}</td>
              <td>
                <a *ngIf="('OR' != row) && ('AND' != row) && !this.readOnly" (click)="onDeleteGivingInterest(row)">
                  <i class="bi bi-trash"></i>
                </a>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <br>
        <br>
        <!--Exclude these cause_giving_interests-->
        <!--
        <div>
          <br>
          <table class="table table-striped webtext-black" style="width:95%">
            <thead>
            <tr>
              <th style="width:85%">Exclude these Cause Category Giving Interest (s)</th>
              <th style="width:15%">Action</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let row of this.nonprofit_causeGivingInterestsWithoutList">
              <td>{{row}}</td>
              <td>
                <a *ngIf="!this.readOnly" (click)="onDeleteGivingInterestWithout(row)">
                  <i class="bi bi-trash"></i>
                </a>
              </td>
            </tr>
            </tbody>
          </table>
        </div>-->

        <br>
        <div>
          <button id="'advanced-filters-button-id'" class="accordionParent webtext-black" (click)="this.toggleAdvancedFilters()"><b>Advanced Filters </b> <b *ngIf="!this.advancedFiltersButton"> (Click to expand) + </b><b *ngIf="this.advancedFiltersButton"> (Click to collapse) - </b></button>
          <br>
        </div>
        <div *ngIf="this.advancedFiltersButton" class="panel">
          <br>
          <div>
            <button id="'nonprofit-ntee-codes-button-id'" class="accordion webtext-white" (click)="this.toggleNonprofitNteeCodesFilter()"><b>NTEE Codes</b> <b *ngIf="!this.nonprofit_nteeCodeButton"> + </b><b *ngIf="this.nonprofit_nteeCodeButton"> - </b></button>
          </div>
          <div *ngIf="this.nonprofit_nteeCodeButton" class="panel">
            <div class="accordion-body" *ngFor="let nteeCodeCheckbox of nonprofit_nteeCodeCheckboxes; let i6 = index">
              <div class="form-check">
                <input class="form-check-input" type="checkbox" value="{{nteeCodeCheckbox['nteeCodeId']}}" id="flexCheckCheckedNonprofitNteeCode-{{i6}}"
                       (click)="addValToNonprofitNteeCodes(i6)" [checked]="nteeCodeCheckbox['checked']" [disabled]="this.readOnly">
                <label class="form-check-label checkbox-text webtext-black" for="flexCheckCheckedNonprofitNteeCode-{{i6}}">
                  {{nteeCodeCheckbox['nteeCode']}}: {{nteeCodeCheckbox['description']}}
                </label>
              </div>
            </div>
            <div>
              <app-st-button *ngIf="this.nonprofit_nteeCodeButton" [idVal]="'see-less-ntee-code-button-id'" [label]="'^ See Less'" [primary]="true"
                             (click)="this.toggleNonprofitNteeCodesFilter()"></app-st-button>
            </div>
          </div>

          <br>
          <div>
            <button id="'nonprofit-ntee-parent-codes-button-id'" class="accordion webtext-white" (click)="this.toggleNonprofitNteeParentCodesFilter()"><b>NTEE Parent Codes</b> <b *ngIf="!this.nonprofit_nteeParentCodeButton"> + </b><b *ngIf="this.nonprofit_nteeParentCodeButton"> - </b></button>
          </div>
          <div *ngIf="this.nonprofit_nteeParentCodeButton" class="panel">
            <div class="accordion-body" *ngFor="let nteeParentCodeCheckbox of nonprofit_nteeParentCodeCheckboxes; let i7 = index">
              <div class="form-check">
                <input class="form-check-input" type="checkbox" value="{{nteeParentCodeCheckbox['nteeParentCodeId']}}" id="flexCheckCheckedNonprofitNteeParentCode-{{i7}}"
                       (click)="addValToNonprofitNteeParentCodes(i7)" [checked]="nteeParentCodeCheckbox['checked']" [disabled]="this.readOnly">
                <label class="form-check-label checkbox-text webtext-black" for="flexCheckCheckedNonprofitNteeParentCode-{{i7}}">
                  {{nteeParentCodeCheckbox['description']}}
                </label>
              </div>
            </div>
            <div>
              <app-st-button *ngIf="this.nonprofit_nteeParentCodeButton" [idVal]="'see-less-ntee-parent-code-button-id'" [label]="'^ See Less'" [primary]="true"
                             (click)="this.toggleNonprofitNteeParentCodesFilter()"></app-st-button>
            </div>
          </div>

          <br>
          <div>
            <button id="'nonprofit-organization-codes-button-id'" class="accordion webtext-white" (click)="this.toggleNonprofitOrganizationCodesFilter()"><b>Organization Codes</b> <b *ngIf="!this.nonprofit_organizationCodeButton"> + </b><b *ngIf="this.nonprofit_organizationCodeButton"> - </b></button>
          </div>
          <div *ngIf="this.nonprofit_organizationCodeButton" class="panel">
            <div class="accordion-body" *ngFor="let organizationCodeCheckbox of nonprofit_organizationCodeCheckboxes; let i8 = index">
              <div class="form-check">
                <input class="form-check-input" type="checkbox" value="{{organizationCodeCheckbox['organizationCodeId']}}" id="flexCheckCheckedNonprofitOrganizationCode-{{i8}}"
                       (click)="addValToNonprofitOrganizationCodes(i8)" [checked]="organizationCodeCheckbox['checked']" [disabled]="this.readOnly">
                <label class="form-check-label checkbox-text webtext-black" for="flexCheckCheckedNonprofitFoundationCode-{{i8}}">
                  {{organizationCodeCheckbox['description']}}
                </label>
              </div>
            </div>
            <div>
              <app-st-button *ngIf="this.nonprofit_organizationCodeButton" [idVal]="'see-less-ntee-organization-code-button-id'" [label]="'^ See Less'" [primary]="true"
                             (click)="this.toggleNonprofitOrganizationCodesFilter()"></app-st-button>
            </div>
          </div>
        </div>

        <br>
        <div>
          <app-st-span [inputVal]="'Sort By Organization: '" class="webtext-black-bold"></app-st-span>
          <div>
            <input class="form-check-input radio-button-properties" type="radio" value="false" id="company-name-asc-radio-button-id"
                   (click)="toggleCompanyNameAscButton()" [checked]="this.companyNameAscRadioButton" [disabled]="this.readOnly">
            <label class="form-check-label webtext-black" for="company-name-asc-radio-button-id">
              &nbsp;ASCENDING
            </label>
            &nbsp;&nbsp;&nbsp;&nbsp;
            <input class="form-check-input radio-button-properties" type="radio" value="false" id="company-name-desc-radio-button-id"
                   (click)="toggleCompanyNameDescButton()" [checked]="this.companyNameDescRadioButton" [disabled]="this.readOnly">
            <label class="form-check-label webtext-black" for="company-name-desc-radio-button-id">
              &nbsp;DESCENDING
            </label>
          </div>
        </div>
        <br>
        <div>
          <app-st-span [inputVal]="'Sort By City: '" class="webtext-black-bold"></app-st-span>
          <div>
            <input class="form-check-input radio-button-properties" type="radio" value="false" id="city-asc-radio-button-id"
                   (click)="toggleCityAscButton()" [checked]="this.cityAscRadioButton" [disabled]="this.readOnly">
            <label class="form-check-label webtext-black" for="city-asc-radio-button-id">
              &nbsp;ASCENDING
            </label>
            &nbsp;&nbsp;&nbsp;&nbsp;
            <input class="form-check-input radio-button-properties" type="radio" value="false" id="city-desc-radio-button-id"
                   (click)="toggleCityDescButton()" [checked]="this.cityDescRadioButton" [disabled]="this.readOnly">
            <label class="form-check-label webtext-black" for="city-desc-radio-button-id">
              &nbsp;DESCENDING
            </label>
          </div>
        </div>
        <br>
        <div>
          <app-st-span [inputVal]="'Sort By State: '" class="webtext-black-bold"></app-st-span>
          <div>
            <input class="form-check-input radio-button-properties" type="radio" value="false" id="state-asc-radio-button-id"
                   (click)="toggleStateAscButton()" [checked]="this.stateAscRadioButton" [disabled]="this.readOnly">
            <label class="form-check-label webtext-black" for="state-asc-radio-button-id">
              &nbsp;ASCENDING
            </label>
            &nbsp;&nbsp;&nbsp;&nbsp;
            <input class="form-check-input radio-button-properties" type="radio" value="false" id="state-desc-radio-button-id"
                   (click)="toggleStateDescButton()" [checked]="this.stateDescRadioButton" [disabled]="this.readOnly">
            <label class="form-check-label webtext-black" for="state-desc-radio-button-id">
              &nbsp;DESCENDING
            </label>
          </div>
        </div>
        <br>
        <div>
          <app-st-span [inputVal]="'Sort By Total Assets: '" class="webtext-black-bold"></app-st-span>
          <div>
            <input class="form-check-input radio-button-properties" type="radio" value="false" id="total-assets-asc-radio-button-id"
                   (click)="toggleTotalAssetsAscButton()" [checked]="this.totalAssetsAscRadioButton" [disabled]="this.readOnly">
            <label class="form-check-label webtext-black" for="total-assets-asc-radio-button-id">
              &nbsp;ASCENDING
            </label>
            &nbsp;&nbsp;&nbsp;&nbsp;
            <input class="form-check-input radio-button-properties" type="radio" value="false" id="total-assets-desc-radio-button-id"
                   (click)="toggleTotalAssetsDescButton()" [checked]="this.totalAssetsDescRadioButton" [disabled]="this.readOnly">
            <label class="form-check-label webtext-black" for="total-assets-desc-radio-button-id">
              &nbsp;DESCENDING
            </label>
          </div>
        </div>

        <!--
        <br>
        <div>
          <button id="'nonprofit-return-type-codes-button-id'" class="accordion webtext-black" (click)="this.toggleNonprofitReturnTypeCodesFilter()">Return Type Codes <b *ngIf="!this.nonprofit_returnTypeCodeButton"> + </b><b *ngIf="this.nonprofit_returnTypeCodeButton"> - </b></button>
        </div>
        <div *ngIf="this.nonprofit_returnTypeCodeButton" class="panel">
          <div class="accordion-body" *ngFor="let returnTypeCodeCheckbox of nonprofit_returnTypeCodeCheckboxes; let i9 = index">
            <div class="form-check">
              <input class="form-check-input" type="checkbox" value="{{returnTypeCodeCheckbox['returnTypeCodeId']}}" id="flexCheckCheckedNonprofitReturnTypeCode-{{i9}}"
                     (click)="addValToNonprofitReturnTypeCodes(i9)" [checked]="returnTypeCodeCheckbox['checked']" [disabled]="true">
              <label class="form-check-label checkbox-text webtext-black" for="flexCheckCheckedNonprofitReturnTypeCode-{{i9}}">
                {{returnTypeCodeCheckbox['returnTypeCodeName']}}
              </label>
            </div>
          </div>
        </div>
        -->
        <!--
        <br>
        <div>
          <button id="'nonprofit-total-assets-button-id'" class="accordion webtext-black" (click)="this.toggleNonprofitTotalAssetsFilter()">Total Assets Range <b *ngIf="!this.nonprofit_totalAssetsButton"> + </b><b *ngIf="this.nonprofit_totalAssetsButton"> - </b></button>
        </div>
        <div *ngIf="this.nonprofit_totalAssetsButton" class="panel">
          <div class="accordion-body" *ngFor="let totalAssetsRadioButton of nonprofit_totalAssetsRadioButtons; let i9 = index">
            <div class="form-check">
              <input class="form-check-input" type="radio" value="{{totalAssetsRadioButton['assetRangeId']}}" id="flexRadioNonprofitTotalAssets-{{i9}}"
                     (click)="trackNonprofitTotalAssetsRange(i9)" [checked]="totalAssetsRadioButton['checked']">
              <label class="form-check-label checkbox-text webtext-black" for="flexRadioNonprofitTotalAssets-{{i9}}">
                {{totalAssetsRadioButton['description']}}
              </label>
            </div>
          </div>
        </div>
        -->
        <!--
        <br>
        <div>
          <button id="'nonprofit-causes-button-id'" class="accordion webtext-black" (click)="this.toggleNonprofitCausesFilter()">Causes Range <b *ngIf="!this.nonprofit_causesButton"> + </b><b *ngIf="this.nonprofit_causesButton"> - </b></button>
        </div>
        <div *ngIf="this.nonprofit_causesButton" class="panel">
          <div class="accordion-body" *ngFor="let causesRadioButton of nonprofit_causesRadioButtons; let i10 = index">
            <div class="form-check">
              <input class="form-check-input" type="radio" value="{{causesRadioButton['causeName']}}" id="flexRadioNonprofitCauses-{{i10}}"
                     (click)="trackNonprofitCauses(i10)" [checked]="causesRadioButton['checked']">
              <label class="form-check-label checkbox-text webtext-black" for="flexRadioNonprofitCauses-{{i10}}">
                {{causesRadioButton['causeNameDisplay']}}
              </label>
            </div>
          </div>
        </div>-->
      </div>
    </div>
    <br>
    <app-st-button-back-to-top></app-st-button-back-to-top>
    <br>
    <div *ngIf="showPageErrorMessages" class="container st-form text-danger" #goUp>
      <app-st-span [inputVal]="'An error has occurred: '"></app-st-span>
      <div *ngFor="let errorMsg of pageErrorMessages" class="alert alert-danger" role="alert">
        <b>{{errorMsg.field}}:</b> {{errorMsg.detail}}
      </div>
      <br>
    </div>
    <br>
    <div class="col2 d-grid gap-2 d-md-flex justify-content-md-end align-items-end">
      <app-st-button-cancel [idVal]="'top-cancel-button-id'" [label]="'Cancel'" [primary]="false"
                            (click)="this.onCancel()"></app-st-button-cancel>
      <app-st-button-delete-all *ngIf="!this.readOnly" [idVal]="'top-reset-filter-button2-id'" [label]="'Reset Filter'"
                                (click)="this.resetFilters()"></app-st-button-delete-all>
      <app-st-button *ngIf="(this.username && this.impersonatedEmail == null) ||
                        (this.impersonatedEmail != null && this.consultantRoleName == 'COLLABORATIVE_ACCESS')"
                     [idVal]="'top-save-button-id'" [label]="'Submit'" [primary]="true"
                     (click)="this.onSubmit(false)"></app-st-button>
      <app-st-button *ngIf="(this.username && this.impersonatedEmail == null) ||
                        (this.impersonatedEmail != null && this.consultantRoleName == 'COLLABORATIVE_ACCESS')"
                     [idVal]="'top-save-and-button2-id'" [label]="'Submit and Apply'" [primary]="true"
                     (click)="this.onSubmit(true)"></app-st-button>
    </div>
  </div>
</div>
